'use strict';

var React = require('react');

var SvgIconsFilledMajor = function SvgIconsFilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.219 14.708c.47-.314.781-.85.781-1.458v-6.5a1.75 1.75 0 0 0-1.75-1.75h-4.587a3.5 3.5 0 1 0-5.663 3.95v4.3c0 .966.784 1.75 1.75 1.75h2.36l-.508.872a.75.75 0 0 0 .648 1.128h7a.75.75 0 0 0 .648-1.128l-.68-1.164Zm-5.219-8.208a3.5 3.5 0 0 1-4.5 3.355v3.395c0 .138.112.25.25.25h3.236l2.116-3.628a.75.75 0 0 1 1.296 0l2.055 3.524a.248.248 0 0 0 .047-.146v-6.5a.25.25 0 0 0-.25-.25h-4.25Z"
  }));
};
SvgIconsFilledMajor.displayName = "IconsFilledMajor";

exports.SvgIconsFilledMajor = SvgIconsFilledMajor;
